/**
 * Inscrição estadual da empresa numa UF em que ela é substituta tributária.
 * Uma linha por UF — a unicidade (idEmpresa + idUnidadeFederativa) é garantida no banco.
 */
export class EmpresaInscricaoSubstitutoTributarioStruct {
    /** Nulo nas linhas ainda não persistidas (adicionadas na tela e não salvas). */
    idEmpresaInscricaoSubstitutoTributario: number | null;
    /**
     * Referência a `unidade_federativa`. A sigla não trafega — a tela já carrega as UFs pelo
     * `UnidadeFederativaService` para montar o select, e faz o bind por este id.
     */
    idUnidadeFederativa: number;
    inscricaoEstadual: string;
}
